import { render, staticRenderFns } from "./previewCard3.vue?vue&type=template&id=2770ca53&scoped=true"
import script from "./previewCard3.vue?vue&type=script&lang=js"
export * from "./previewCard3.vue?vue&type=script&lang=js"
import style0 from "./previewCard3.vue?vue&type=style&index=0&id=2770ca53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2770ca53",
  null
  
)

export default component.exports